export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  description: string;
  tags: string[];
  rating: number;
  views: number;
  chapters: number;
  status: '连载中' | '已完结';
  updateDate: string;
  featured?: boolean;
  readerReviews?: ReaderReview[];
  relatedComics?: string[];
}

export interface ReaderReview {
  id: string;
  userName: string;
  avatar: string;
  rating: number;
  content: string;
  platform: string;
  date: string;
}

export interface Category {
  name: string;
  slug: string;
  count: number;
}

export const categories: Category[] = [
  { name: '浪漫爱情', slug: 'romance', count: 128 },
  { name: '奇幻冒险', slug: 'fantasy', count: 96 },
  { name: '都市生活', slug: 'urban', count: 84 },
  { name: '悬疑推理', slug: 'mystery', count: 62 },
  { name: '动作热血', slug: 'action', count: 73 },
  { name: '搞笑日常', slug: 'comedy', count: 55 },
  { name: '恐怖灵异', slug: 'horror', count: 41 },
  { name: '历史古风', slug: 'historical', count: 38 },
];

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '星光下的约定',
    author: '金秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20couple%20under%20starry%20night%20sky%2C%20soft%20watercolor%20style%2C%20warm%20pink%20and%20navy%20tones%2C%20delicate%20lineart%2C%20dreamy%20atmosphere%2C%20elegant%20character%20design%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-001&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    description: '在繁华的首尔街头，两个素不相识的灵魂因为一场意外的相遇而命运交织。她是一名追逐梦想的插画师，他是一位冷静理性的建筑设计师。当星光洒落的夜晚，他们在汉江边许下了彼此最珍贵的约定。这段跨越阶级与偏见的爱情，将在时光的考验中绽放出最动人的光芒。',
    tags: ['纯爱', '都市', '治愈'],
    rating: 4.8,
    views: 1520000,
    chapters: 86,
    status: '连载中',
    updateDate: '2026-07-07',
    featured: true,
    readerReviews: [
      {
        id: 'review-001',
        userName: '漫画迷小樱',
        avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20soft%20natural%20lighting%2C%20simple%20white%20background%2C%20warm%20smile%2C%20casual%20elegant%20style%2C%20clean%20professional%20headshot&width=200&height=200&seq=avatar-001&orientation=portrait',
        rating: 5,
        content: '画风真的太美了！每一帧都像是一幅精致的插画，故事情节也特别打动人。男女主角的性格塑造非常立体，完全停不下来！',
        platform: '桃桃漫画',
        date: '2026-07-05',
      },
    ],
  },
  {
    id: 'comic-002',
    title: '异世界剑圣',
    author: '李俊昊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20action%20manhwa%20cover%2C%20swordsman%20with%20glowing%20sword%20in%20epic%20battle%20pose%2C%20dramatic%20lighting%20with%20magic%20effects%2C%20dark%20atmospheric%20background%2C%20detailed%20armor%20design%2C%20professional%20illustration%20with%20clean%20composition&width=800&height=1120&seq=comic-cover-002&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '平凡的程序员金哲秀在加班途中意外穿越到剑与魔法的世界。在这个充满危险与机遇的异世界中，他凭借现代人的思维和对游戏的理解，一步步成长为最强的剑圣。然而，随着实力的增长，他逐渐发现这个世界的秘密远比想象中更加深邃。',
    tags: ['穿越', '战斗', '升级'],
    rating: 4.6,
    views: 2380000,
    chapters: 124,
    status: '连载中',
    updateDate: '2026-07-06',
    featured: true,
  },
  {
    id: 'comic-003',
    title: '办公室罗曼史',
    author: '朴美英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%2C%20elegant%20couple%20in%20modern%20office%20setting%2C%20soft%20warm%20lighting%2C%20professional%20attire%2C%20gentle%20romantic%20atmosphere%2C%20clean%20minimal%20composition%2C%20muted%20pastel%20color%20palette%2C%20refined%20illustration%20style&width=800&height=1120&seq=comic-cover-003&orientation=portrait',
    category: '都市生活',
    categorySlug: 'urban',
    description: '刚毕业的职场新人林多海进入韩国最大的广告公司，却不料直属上司竟然是大学时暗恋过的学长。在工作与情感的交织中，她必须学会平衡事业与爱情。办公室里的每一次擦肩而过，都暗藏着心动的瞬间。',
    tags: ['职场', '恋爱', '成长'],
    rating: 4.5,
    views: 980000,
    chapters: 56,
    status: '连载中',
    updateDate: '2026-07-04',
    featured: false,
  },
  {
    id: 'comic-004',
    title: '暗夜追踪者',
    author: '郑宇镇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20cover%2C%20detective%20in%20dark%20rainy%20alley%2C%20noir%20atmosphere%2C%20dramatic%20shadows%20and%20neon%20signs%2C%20tense%20mood%2C%20professional%20illustration%2C%20clean%20dark%20composition%2C%20mysterious%20vibe&width=800&height=1120&seq=comic-cover-004&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'mystery',
    description: '首尔连续发生离奇失踪案件，刑警姜道贤在追查过程中发现所有线索都指向一个名为"暗夜"的神秘组织。随着调查的深入，他发现自己也被卷入了一场巨大的阴谋之中。真相，远比想象中更加残酷。',
    tags: ['刑警', '悬疑', '反转'],
    rating: 4.7,
    views: 1850000,
    chapters: 72,
    status: '连载中',
    updateDate: '2026-07-05',
    featured: true,
  },
  {
    id: 'comic-005',
    title: '格斗天王',
    author: '韩泰雄',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20fighting%20manhwa%20cover%2C%20martial%20artist%20in%20dynamic%20fighting%20stance%2C%20intense%20energy%20effects%2C%20dark%20dramatic%20background%2C%20powerful%20composition%2C%20detailed%20muscle%20anatomy%2C%20professional%20illustration%20with%20impact%20lines&width=800&height=1120&seq=comic-cover-005&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    description: '曾经的格斗冠军因伤退役后沦为街头混混，直到一天他遇到了改变他命运的师父。在严酷的训练与不断的战斗中，他重新找回了格斗的真谛和对生活的热爱。终极擂台，等待着他的回归。',
    tags: ['格斗', '热血', '逆袭'],
    rating: 4.4,
    views: 1200000,
    chapters: 94,
    status: '连载中',
    updateDate: '2026-07-03',
    featured: false,
  },
  {
    id: 'comic-006',
    title: '猫咪咖啡厅',
    author: '尹智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20cute%20slice%20of%20life%20manhwa%20cover%2C%20cat%20cafe%20with%20adorable%20cats%20and%20barista%2C%20cozy%20warm%20interior%2C%20soft%20pastel%20colors%2C%20heartwarming%20atmosphere%2C%20simple%20clean%20composition%2C%20charming%20illustration%20style&width=800&height=1120&seq=comic-cover-006&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'comedy',
    description: '失业青年李河娜阴差阳错接手了一家濒临倒闭的猫咪咖啡厅。在这里，她遇到了形形色色的顾客和他们带来的猫咪，每一只猫都有自己的故事。温暖治愈的日常，在咖啡的香气中缓缓展开。',
    tags: ['治愈', '猫咪', '日常'],
    rating: 4.9,
    views: 890000,
    chapters: 48,
    status: '连载中',
    updateDate: '2026-07-06',
    featured: false,
  },
  {
    id: 'comic-007',
    title: '幽灵公寓',
    author: '崔贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20supernatural%20manhwa%20cover%2C%20haunted%20apartment%20building%20at%20night%2C%20eerie%20atmosphere%20with%20ghostly%20figure%2C%20dark%20muted%20tones%2C%20spooky%20mood%2C%20professional%20illustration%2C%20clean%20composition%20with%20cold%20color%20palette&width=800&height=1120&seq=comic-cover-007&orientation=portrait',
    category: '恐怖灵异',
    categorySlug: 'horror',
    description: '搬到首尔一栋廉价公寓的大学生开始经历一连串无法解释的诡异事件。每到午夜时分，走廊里总会传来神秘的脚步声，而监控录像中却空无一人。他决定深入调查这栋公寓的秘密，却发现真相远比想象中的更加恐怖。',
    tags: ['恐怖', '灵异', '惊悚'],
    rating: 4.3,
    views: 760000,
    chapters: 36,
    status: '连载中',
    updateDate: '2026-07-02',
    featured: false,
  },
  {
    id: 'comic-008',
    title: '花都风云',
    author: '安孝珍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20historical%20romance%20manhwa%20cover%2C%20noblewoman%20in%20traditional%20hanbok%20with%20cherry%20blossoms%2C%20elegant%20classical%20Korean%20aesthetic%2C%20soft%20warm%20lighting%2C%20detailed%20traditional%20patterns%2C%20refined%20illustration%2C%20peaceful%20garden%20background&width=800&height=1120&seq=comic-cover-008&orientation=portrait',
    category: '历史古风',
    categorySlug: 'historical',
    description: '朝鲜王朝时期，一位出身卑微的女子凭借智慧与勇气进入宫廷。在尔虞我诈的权力斗争中，她与年轻的王相遇相知。然而，宫廷的规则和王室的枷锁，成为横亘在两人之间无法逾越的高墙。',
    tags: ['古风', '宫斗', '爱情'],
    rating: 4.8,
    views: 1350000,
    chapters: 108,
    status: '已完结',
    updateDate: '2026-06-30',
    featured: true,
  },
  {
    id: 'comic-009',
    title: '校园魔法部',
    author: '宋智浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20school%20manhwa%20cover%2C%20students%20with%20magical%20powers%20in%20academy%20setting%2C%20bright%20colorful%20magic%20effects%2C%20energetic%20atmosphere%2C%20modern%20school%20uniforms%2C%20dynamic%20composition%2C%20professional%20illustration&width=800&height=1120&seq=comic-cover-009&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '在看似普通的韩国高中里，隐藏着一个秘密的魔法社团。社团成员们各自拥有独特的魔法能力，他们一边应对繁重的学业，一边守护着学校免受黑暗力量的侵袭。青春与魔法的碰撞，精彩纷呈。',
    tags: ['校园', '魔法', '青春'],
    rating: 4.5,
    views: 1120000,
    chapters: 64,
    status: '连载中',
    updateDate: '2026-07-07',
    featured: false,
  },
  {
    id: 'comic-010',
    title: '顶级大厨',
    author: '张美兰',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20cooking%20manhwa%20cover%2C%20chef%20presenting%20gourmet%20dish%20in%20professional%20kitchen%2C%20warm%20lighting%2C%20delicious%20food%20styling%2C%20elegant%20presentation%2C%20clean%20composition%2C%20professional%20illustration%20with%20rich%20colors&width=800&height=1120&seq=comic-cover-010&orientation=portrait',
    category: '都市生活',
    categorySlug: 'urban',
    description: '从法国蓝带学成归来的天才厨师在首尔开设了一家小小的餐厅。她坚持用最优质的食材和最精湛的技艺征服每一位食客的味蕾。在美食的世界里，她不仅找到了事业的巅峰，也收获了意外的爱情。',
    tags: ['美食', '职场', '恋爱'],
    rating: 4.6,
    views: 670000,
    chapters: 42,
    status: '连载中',
    updateDate: '2026-07-01',
    featured: false,
  },
  {
    id: 'comic-011',
    title: '武道宗师',
    author: '刘在石',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%2C%20elder%20master%20teaching%20young%20student%20in%20traditional%20dojo%2C%20warm%20golden%20lighting%2C%20serene%20atmosphere%2C%20traditional%20Korean%20architecture%2C%20clean%20composition%2C%20dignified%20illustration%20style&width=800&height=1120&seq=comic-cover-011&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    description: '武道世家的传人从小接受严苛的训练，却始终无法超越父亲的光环。在一次意外中，他获得了一本古老的武学秘籍，从此踏上了追求武道极致的旅程。传统与现代的碰撞，铸就了新一代的武道传奇。',
    tags: ['武术', '传承', '成长'],
    rating: 4.7,
    views: 1450000,
    chapters: 88,
    status: '连载中',
    updateDate: '2026-07-05',
    featured: true,
  },
  {
    id: 'comic-012',
    title: '深夜书店',
    author: '韩佳人',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%2C%20cozy%20bookstore%20at%20night%20with%20warm%20yellow%20lights%2C%20bookshelves%20and%20reading%20nook%2C%20peaceful%20atmosphere%2C%20soft%20warm%20tones%2C%20vintage%20aesthetic%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-012&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'comedy',
    description: '一家只在深夜营业的独立书店，店主是一位神秘的年轻女子。每个深夜到访的顾客，都带着自己独特的故事和烦恼。在这里，书籍成为了连接人心的桥梁，温暖了每一个孤独的夜晚。',
    tags: ['治愈', '书店', '温情'],
    rating: 4.8,
    views: 560000,
    chapters: 30,
    status: '连载中',
    updateDate: '2026-07-07',
    featured: false,
  },
];

export function getFeaturedComics(): Comic[] {
  return comics.filter((c) => c.featured);
}

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getRelatedComics(id: string, limit: number = 4): Comic[] {
  const comic = getComicById(id);
  if (!comic) return [];
  return comics
    .filter((c) => c.id !== id && c.categorySlug === comic.categorySlug)
    .slice(0, limit);
}

export function getLatestComics(limit: number = 6): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);
}